(function () {
    angular.module('app')
        .factory('api', api);

    api.$inject = ['$resource','bmgLogger'];
    function api($resource, bmgLogger) {

        return {
            //authentication
            token: $resource('/api/main/token/'),
            //surveys
            users: $resource('https://secure3.convio.net/ugm/site/CRSurveyAPI', {}, {
                get: {
                    method: 'POST',
                    transformRequest: function (data, headers) {
                        var result = '';
                        var first = true;
                        for (var key in data) {
                            if (!first) {
                                result += '&';
                            }
                            result += (key + '=' + data[key]);
                            first = false;
                        }
                        return result;
                    },
                    transformResponse: function (data) {
                        return JSON.parse(data);
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            }),
            surveys: $resource('https://secure3.convio.net/ugm/site/CRSurveyAPI', {}, {
                get: {
                    method: 'POST',
                    transformRequest: function (data, headers) {
                        var result = '';
                        var first = true;
                        for (var key in data) {                            
                            if (!first) {
                                result += '&';
                            }
                            result += (key + '=' + data[key]);
                            first = false;
                        }
                        return result;
                    },
                    transformResponse: function (data) {
                        return JSON.parse(data);
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },
                post: {
                    method: 'POST',
                    transformRequest: function (data, headers) {
                        var result = '';
                        var first = true;
                        for (var key in data) {                            
                            if (!first) {
                                result += '&';
                            }
                            if (Array.isArray(data[key])) {                                              
                                for (var i = 0; i < data[key].length; i++) {                                    
                                    if (i>0) {
                                        result += '&';                                        
                                    }
                                    result += (key + '=' + data[key][i]);
                                }                                                           
                            }
                            else {
                                result += (key + '=' + data[key]);
                            }                            
                            first = false;
                        }
                        //console.info('posting data...');
                        //bmgLogger.info(result);                        
                        return result;
                    },
                    transformResponse: function (data) {
                        return JSON.parse(data);
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            }),
            luminateSurveys: $resource('/api/luminate/survey/:id', { id: '@id'})
        };
    }
})();